module.exports = __webpack_public_path__ + "img/chapter__6_image_2.35e5478b.png";